import { CountriesMap, Country } from '../types';
import { commonCountries, continentSort } from '../constants';

export const sortCountries = (countries: CountriesMap) => {
  const allCountries = Object.keys(countries).reduce((acc, val) => {
    return [...acc, ...countries[val]];
  }, [] as Country[]);
  const mostCommon = commonCountries.reduce((acc, commonId) => {
    const country = allCountries.find((val) => val.id === commonId);
    if (country) {
      return [...acc, country];
    } else {
      return acc;
    }
  }, [] as Country[]);
  const sortedCountries = continentSort.reduce(
    (acc, val) => (countries[val] ? { ...acc, [val]: countries[val] } : acc),
    {}
  );
  return {
    countries: sortedCountries,
    mostCommon,
  };
};
